
export {
    getContractAppText,
    getAppEnvText,
    getContractServerText,
    getAuthorityText,
    getStatusText,
    CONTRACT_APP_PAC,
    CONTRACT_APP_PAC2
}

//contract_app
const CONTRACT_APP_PAC = 0;
const CONTRACT_APP_PAC2 = 1;

//App_env
const APP_ENV_AWS = 0;
const APP_ENV_K5 = 1;

//Authority
const AUTH_NONE = 0;
const AUTH_USER = 1;
const AUTH_ADMIN = 2;
const AUTH_AUDIT = 3;
const AUTH_OPTION = 4;
const AUTH_RECEIVE = 5;

//Status
const STATUS_VALID = 0;
const STATUS_INVALID = 1;
const STATUS_DELETE = 9;

function getContractAppText(contract_app) {
    if (contract_app === '') return ''
    switch (+contract_app) {
        case CONTRACT_APP_PAC:
            return 'PAC';
        case CONTRACT_APP_PAC2:
            return 'PAC2';
        default:
            return '';
    }
}

function getAppEnvText(app_env) {
    if (app_env === '') return ''
    switch (+app_env) {
        case APP_ENV_AWS:
            return 'AWS';
        case APP_ENV_K5:
            return 'K5';
        default:
            return '';
    }
}

function getContractServerText(contract_server) {
    if (contract_server === '') return ''
    return `${+contract_server + 1}号機`;
}

function getAuthorityText(auth) {
    switch (auth) {
        case AUTH_NONE:
            return 'なし';
        case AUTH_USER:
            return '利用者';
        case AUTH_ADMIN:
            return '管理者';
        case AUTH_AUDIT:
            return '監査用アカウント';
        case AUTH_OPTION:
            return 'オプション利用者';
        case AUTH_RECEIVE:
            return '受信専用利用者';
        default:
            return '';
    }
}

function getStatusText(status) {
    switch (status) {
        case STATUS_VALID:
            return '有効';
        case STATUS_INVALID:
            return '無効';
        case STATUS_DELETE:
            return '削除';
        default:
            return '';
    }
}